<script lang="ts">
  import type { ArtAsset } from '@entities/art-asset';

  import ArtistInfo from './artist-info.svelte';

  export let artists: ArtAsset['artists'];

  $: filteredArtists = artists.filter((artist) => artist.name && artist.photo && artist.biography);
</script>

{#if filteredArtists?.length}
  <div class="flex flex-wrap gap-x-16 gap-y-6 lg:gap-x-20">
    {#each filteredArtists as artist, index}
      {@const countries = artist.countries?.length ? artist.countries.map(({ name }) => name).join(', ') : ''}

      <div class="mb-4 flex w-full flex-wrap gap-10">
        <ArtistInfo
          {countries}
          name="{artist.name}"
          description="{artist.biography?.blocks}"
          photo="{artist.photo}"
          status="{artist.status}"
          slug="{artist.slug}"
          dateOfBirth="{artist.date_of_birth}"
          id="{artist.id}"
        />
      </div>

      {#if index !== filteredArtists.length - 1}
        <div class="bg-default-300 dark:bg-dark-400 -ml-6 -mr-6 h-[1px] w-[calc(100%+48px)]"></div>
      {/if}
    {/each}

    <!-- {#if institutions}
      <div>
        <p class="mb-4 text-default-500 dark:text-dark-500">Presented by</p>
        <div class="mb-2">
          {#each institutions as institution}
            <AvatarWithText
              isInvertDark
              title=""
              name="{institution.name}"
              imageData="{institution.logo}"
              linkUrl="{`/gallery-${institution.id}`}"
            />
          {/each}
        </div>
      </div>
    {/if} -->
  </div>
{/if}
